import React, { useContext, useMemo, useState } from "react";
import { GetMe } from "@ticketingplatform/api/dist/user/__generated__/GetMe";
import { useMeQuery } from "@ticketingplatform/api/dist/user/hooks";

interface UserContextValue {
  user: GetMe | undefined;
  isLoading: boolean;
  refetch: () => Promise<void>;
}

const UserContext = React.createContext<UserContextValue>({
  isLoading: true,
  refetch: () => Promise.resolve(),
  user: undefined,
});

interface UserContextProviderProps {
  children: (params: { isInitializing: boolean }) => React.ReactNode;
}

export const UserContextProvider: React.FC<UserContextProviderProps> = ({
  children,
}) => {
  const [isInitializing, setIsInitializing] = useState(true);
  const { refetch, loading, data } = useMeQuery({
    onCompleted: () => {
      setIsInitializing(false);
    },
    onError: () => {
      setIsInitializing(false);
    },
  });
  const value = useMemo(
    () => ({
      isLoading: loading,
      refetch: async () => {
        await refetch();
      },
      user: data,
    }),
    [data, loading, refetch]
  );

  return (
    <UserContext.Provider {...{ value }}>
      {children({ isInitializing })}
    </UserContext.Provider>
  );
};

export const useUserContext = (): UserContextValue => useContext(UserContext);
